module.exports = __webpack_public_path__ + "img/check.711d649e.svg";